import React, { Component } from 'react';

import Layout from './components/Layout';
import './App.css';
import axios from "axios/index";


class App extends Component {
  render() {
    return (
      <Layout/>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js